import { c as _c } from "react/compiler-runtime";
import { DEFAULT_DRAW_ID } from '../../../../lib/entry.browser.js';
import { useCouponOutcomes } from './useCouponOutcomes.js';
import { encodeSigns } from './utils/encodeSigns.js';
const DRAW_ID_SEGMENT_PATTERN = new RegExp(String.raw`^(?:${DEFAULT_DRAW_ID}|\d+)(?:-[\dA-Za-z]+)?$`);
/**
 * Hook to create a shareable coupon url.
 *
 * The draw is embedded into the pathname as the `[drawId]` segment in the
 * canonical `drawNumber-product` format (matching `parseDrawId`).
 *
 * @param root0 - The props object.
 * @param root0.product - The current product
 * @param root0.couponId - The current coupon id
 * @param root0.boardIndex - The current board index
 * @param root0.couponIndex - The current coupon index
 * @param root0.drawNumber - The current draw number
 * @returns A shareable coupon url string
 */
export function useShareableCouponUrl(t0) {
  const $ = _c(4);
  const {
    product,
    couponId,
    boardIndex,
    couponIndex,
    drawNumber
  } = t0;
  const url = new URL(window.location.href);
  const segments = url.pathname.split("/").filter(Boolean);
  const drawIdSegment = drawNumber === undefined ? undefined : product ? `${drawNumber}-${product}` : `${drawNumber}`;
  let hasReplacedDrawId = false;
  const updatedSegments = segments.filter(_temp).map(segment_0 => {
    if (drawIdSegment && !hasReplacedDrawId && DRAW_ID_SEGMENT_PATTERN.test(segment_0)) {
      hasReplacedDrawId = true;
      return drawIdSegment;
    }
    return segment_0;
  });
  url.pathname = `/${updatedSegments.join("/")}`;
  let t1;
  if ($[0] !== boardIndex || $[1] !== couponId || $[2] !== couponIndex) {
    t1 = {
      couponId,
      couponIndex,
      boardIndex
    };
    $[0] = boardIndex;
    $[1] = couponId;
    $[2] = couponIndex;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const outcomes = useCouponOutcomes(t1);
  const outcomesString = encodeSigns(outcomes);
  if (outcomesString) {
    url.searchParams.set("outcomes", outcomesString);
  }
  const urlString = url.toString();
  return urlString;
}
function _temp(segment) {
  return segment !== "din-kupong";
}